import { NgIf } from '@angular/common';
import { FieldType, FormlyFieldProps } from '@ngx-formly/bootstrap/form-field';
import { FieldTypeConfig } from '@ngx-formly/core';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { TooltipComponent } from '../../../../../shared/component/tooltip/tooltip.component';

interface LabelProps extends FormlyFieldProps {
  tooltip?: string;
}

// noinspection CssUnknownTarget
@Component({
  selector: 'app-label-field',
  template: `
    <p class="short-label">
      {{ props.label | translate }}
      <app-tooltip
        *ngIf="props.tooltip"
        [tooltip]="props.tooltip"></app-tooltip>
    </p>
  `,
  styles: `
    p.short-label {
      display: flex;
      align-items: center;
      gap: 8px;
      color: var(--p-greyscale-700);
      font-size: 14px;
      margin-bottom: 32px;
      margin-top: -32px;
      font-weight: 500;
    }
  `,
  imports: [TranslatePipe, TooltipComponent, NgIf],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ShortLabelFieldComponent extends FieldType<
  FieldTypeConfig<LabelProps>
> {}
